var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagType,{tag:"component",class:`${_vm.carbonPrefix}--content`},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }